module.exports = __webpack_public_path__ + "static/img/chain.b8aa77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/chain.png
// module id = hejj
// module chunks = 0